<template>
  <div class="party-activity-detail-container animated fadeInRight">
    <el-card class="box-card">
      <div class="flex justify-between">
        <div class="text-title">{{ $t('partyActivityDetail.title') }}</div>
        <div>
          <el-button type="primary" size="small" @click="goBack">{{ $t('common.back') }}</el-button>
        </div>
      </div>

      <div class="margin-top">
        <el-row :gutter="20" class="text-left">
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('partyActivityDetail.activityTitle') }}</label>
                  <label class="">{{ detailInfo.title }}</label>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('partyActivityDetail.address') }}</label>
                  <label class="">{{ detailInfo.address }}</label>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('partyActivityDetail.status') }}</label>
                  <label class="">
                    <el-tag :type="getStatusTagType()" size="small">{{ getStatusText() }}</el-tag>
                  </label>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('partyActivityDetail.signTime') }}</label>
                  <label class="">{{ detailInfo.signStartTime }} ~ {{ detailInfo.signEndTime }}</label>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('partyActivityDetail.activityTime') }}</label>
                  <label class="">{{ detailInfo.startTime }} ~ {{ detailInfo.endTime }}</label>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('partyActivityDetail.duration') }}</label>
                  <label class="">{{ detailInfo.duration }}{{ $t('common.hour') }}</label>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('partyActivityDetail.coverImage') }}</label>
                  <label class="">
                    <el-image v-if="detailInfo.coverUrl" :src="detailInfo.coverUrl" style="width:200px;height:auto" fit="cover" :preview-src-list="[detailInfo.coverUrl]" />
                    <span v-else>-</span>
                  </label>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('partyActivityDetail.content') }}</label>
                  <label class="">{{ detailInfo.content }}</label>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card style="margin-top:20px">
      <div slot="header">
        <span>{{ $t('partyActivityDetail.signList') }}</span>
      </div>
      <el-table :data="signList" border style="width:100%" v-loading="signLoading">
        <el-table-column type="index" :label="$t('partyActivityDetail.serial')" align="center" width="60" />
        <el-table-column prop="name" :label="$t('partyActivityDetail.signName')" align="center" />
        <el-table-column prop="phone" :label="$t('partyActivityDetail.signPhone')" align="center" />
        <el-table-column prop="createTime" :label="$t('partyActivityDetail.signTime')" align="center" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getPartyActivity, listPartyActivitySigns } from '@/api/party/partyActivityApi'

export default {
  name: 'PartyActivityDetail',
  data() {
    return {
      detailInfo: {
        title: '',
        address: '',
        status: '',
        signStartTime: '',
        signEndTime: '',
        startTime: '',
        endTime: '',
        duration: '',
        content: ''
      },
      signList: [],
      signLoading: false
    }
  },
  created() {
    const activityId = this.$route.query.activityId
    if (activityId) {
      this._loadDetail(activityId)
      this._loadSignList(activityId)
    }
  },
  methods: {
    async _loadDetail(activityId) {
      try {
        const res = await getPartyActivity({ activityId })
        // 后端返回 {code:0, data:[...]} 数组格式
        let data = res.data
        if (Array.isArray(data)) {
          data = data[0]
        }
        if (data) {
          Object.assign(this.detailInfo, data)
        }
      } catch (error) {
        this.$message.error(this.$t('common.operationFailed'))
      }
    },
    async _loadSignList(activityId) {
      try {
        this.signLoading = true
        const { data } = await listPartyActivitySigns({ activityId, page: 1, row: 100 })
        this.signList = data || []
      } catch (error) {
        console.error('获取报名列表失败:', error)
      } finally {
        this.signLoading = false
      }
    },
    _getActivityStatus() {
      const now = new Date()
      const d = this.detailInfo
      const signStart = d.signStartTime ? new Date(d.signStartTime.replace(/-/g, '/')) : null
      const signEnd = d.signEndTime ? new Date(d.signEndTime.replace(/-/g, '/')) : null
      const actStart = d.startTime ? new Date(d.startTime.replace(/-/g, '/')) : null
      const actEnd = d.endTime ? new Date(d.endTime.replace(/-/g, '/')) : null
      if (signStart && now < signStart) return 'notStarted'
      if (signStart && signEnd && now >= signStart && now <= signEnd) return 'signing'
      if (signEnd && actStart && now > signEnd && now < actStart) return 'signupEnded'
      if (actStart && actEnd && now >= actStart && now <= actEnd) return 'ongoing'
      if (actEnd && now > actEnd) return 'finished'
      return 'notStarted'
    },
    getStatusText() {
      const map = {
        notStarted: this.$t('partyActivity.status.notStarted'),
        signing: this.$t('partyActivity.status.signing'),
        signupEnded: this.$t('partyActivity.status.signupEnded'),
        ongoing: this.$t('partyActivity.status.ongoing'),
        finished: this.$t('partyActivity.status.finished')
      }
      return map[this._getActivityStatus()] || ''
    },
    getStatusTagType() {
      const map = { notStarted: 'info', signing: 'warning', signupEnded: '', ongoing: 'success', finished: 'info' }
      return map[this._getActivityStatus()] || 'info'
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.party-activity-detail-container {
  padding: 20px;

  .box-card {
    padding: 20px;
  }

  .text-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }

  .margin-top {
    margin-top: 20px;
  }

  .form-group {
    margin-bottom: 15px;

    .col-form-label {
      margin-bottom: 5px;
      color: #606266;
      margin-right: 10px;
    }
  }
}
</style>
